import { LocalStorageKeys } from 'commons';

/**
 *
 * @param key - LocalStorage key
 * @param defaultValue - Value that will be returned if the storage is empty. If not declared and the store is empty, the value returned will be undefined
 * @returns - Parsed localStorage value or defaultValue | undefined
 */
export function getLocalStorageItem<T>(
  key: LocalStorageKeys,
  defaultValue?: T
) {
  const initialValue = defaultValue;
  if (typeof window === 'undefined') return initialValue;
  const saved = localStorage.getItem(key);
  return saved !== null ? JSON.parse(saved) : initialValue;
}

export function removeLocalStorageItem(key: LocalStorageKeys) {
  localStorage.removeItem(key);
}

export function setLocalStorageItem<T>(key: LocalStorageKeys, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getTodayStoredData<T>(
  localStorageKey: LocalStorageKeys,
  initialValue: T
): T {
  const storedValue = getLocalStorageItem(localStorageKey, undefined);

  if (!storedValue) {
    return initialValue;
  }

  const today = new Date().toDateString();
  const isTodayStorage = storedValue.storageDate === today;
  if (!isTodayStorage) {
    return initialValue;
  }

  Reflect.deleteProperty(storedValue, 'storageDate');

  return storedValue;
}

export function setTodayLocalStorage<T>(
  localStorageKey: LocalStorageKeys,
  data: T
) {
  setLocalStorageItem(localStorageKey, {
    ...data,
    storageDate: new Date().toDateString(),
  });
}
